import React from 'react';
import {Form} from 'semantic-ui-react';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ApiActions from 'go/actions/api';
import {API_AUTH_LOGIN_FAILURE} from 'common/types';
import AccountWrapper from 'go/pages/account/AccountWrapper';
import {checkIfValuesAre, isloginGovError} from 'common/utils';
import _ from 'lodash';

const isRequired = (val) => {
  return !checkIfValuesAre([undefined, null, ''], val);
};

const errorMapping = {
  firstName: {
    test: isRequired,
    msg: 'Please enter your first name',
  },
  lastName: {
    test: isRequired,
    msg: 'Please enter your last name',
  },
};

// after login gov authentication for new (non-orphaned) user
// come to this page to complete profile information (fn/ln)
export class ProvideProfileInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      confirmation: '',
      email: '',
      formHasErrors: true,
      token: '',
      loading: true,
      blurred: {
        firstName: false,
        lastName: false,
      },
    };
  }

  handleSubmit = (e) => {
    this.setState({backendErrorMsg: false});
    let {firstName, lastName} = this.state;

    const response = this.props.completeLgAccount(
      this.state.firstName,
      this.state.lastName
    );
    response
      .then((res) => {
        if (isloginGovError() || res.type === API_AUTH_LOGIN_FAILURE) {
          this.props.navigateToLogin();
        } else {
          this.props.loginSuccess();
        }
      })
      .catch((err) => {
        this.props.navigateToLogin();
      });
  };

  getErrorMessageForField(fieldName) {
    // if it passes the test, no errors
    if (!errorMapping[fieldName].test(this.state[fieldName])) {
      return errorMapping[fieldName].msg;
    } else {
      return '';
    }
  }

  handleChange = (name, value) => {
    this.setState(
      () => {
        let stateToMerge = {};
        stateToMerge[name] = value;
        return stateToMerge;
      },
      () => {
        const firstNameErrors = this.getErrorMessageForField('firstName');
        const lastNameErrors = this.getErrorMessageForField('lastName');
        this.setState({
          formHasErrors: firstNameErrors || lastNameErrors,
        });
      }
    );
  };

  handleBlur = (name, value) => {
    let newBlurred = Object.assign({}, this.state.blurred);
    newBlurred[name] = true;
    this.setState({
      blurred: newBlurred,
    });
  };

  render() {
    const {formHasErrors, firstName, lastName, blurred} = this.state;
    const firstNameErrors = this.getErrorMessageForField('firstName');
    const lastNameErrors = this.getErrorMessageForField('lastName');
    return (
      <React.Fragment>
        <AccountWrapper
          title="New user information"
          confirmAction={this.handleSubmit}
          cancelAction={this.navigateToLogin}
          disabled={formHasErrors}
          buttonText="Submit"
          cancelToLogin
        >
          <Form error>
            <Form.Field>
              <TextBoxField
                value={firstName}
                label="First name"
                id="firstName"
                title={'Required: First Name'}
                name="firstName"
                displayError={blurred.firstName && firstNameErrors}
                handleChange={(e, data) => {
                  this.handleChange(data.name, _.trim(data.value));
                }}
                handleBlur={(e) => {
                  const {name, value} = e.target;
                  this.handleBlur(name, value);
                }}
                maxLength={101}
                errorMessages={blurred.firstName && firstNameErrors}
              />
            </Form.Field>
            <Form.Field>
              <TextBoxField
                value={lastName}
                label="Last name"
                id="lastName"
                title={'Required: Last Name'}
                name="lastName"
                displayError={blurred.lastName && lastNameErrors}
                handleChange={(e, data) => {
                  this.handleChange(data.name, _.trim(data.value));
                }}
                handleBlur={(e) => {
                  const {name, value} = e.target;
                  this.handleBlur(name, value);
                }}
                maxLength={101}
                errorMessages={blurred.lastName && lastNameErrors}
              />
            </Form.Field>
          </Form>
        </AccountWrapper>
      </React.Fragment>
    );
  }
}

const emptyStr = '';

export const mapDispatchToProps = (dispatch) => {
  return {
    completeLgAccount: (firstName, lastName) => {
      const action = ApiActions.auth.completeLGUserAccount(firstName, lastName);
      const response = dispatch(action);
      return response;
    },
    loginSuccess: () => {
      window.location.href = '/';
    },
    navigateToLogin: () => {
      dispatch(push('/login'));
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    toggles: _.get(state, 'toggles.toggles'),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProvideProfileInfo);
